import {Link, Stack, Typography, TypographyProps} from "@mui/material";
import React, {MouseEvent, useCallback} from "react";
import {Employee, EmployeeRef} from "../../api/Model";
import {Tag} from "../tag/Tag";
import {useEmployeeMapStore} from "../../api/EmployeeMapStore";


export function hibobEmployeeUrl(employee: Employee) {
    return `https://app.hibob.com/employee-profile/${employee.hibobId}`;
}

export async function openHibobLink(employeeRef: EmployeeRef) {
    const employee: Employee | undefined = (employeeRef as Employee).hibobId
        ? employeeRef as Employee
        : (await useEmployeeMapStore.getState().remoteValue.value).get(employeeRef);

    if (employee) {
        const url = hibobEmployeeUrl(employee);
        window.open(url, '_blank');
    }
}

export default function EmployeeLink({employee, ...props}: {
    employee: EmployeeRef,
} & TypographyProps) {
    const onClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
        event.stopPropagation();
        openHibobLink(employee);
    }, [employee])

    return (
        <Link onClick={onClick} sx={{cursor: 'pointer', textDecoration: 'none'}}>
            <Stack direction="row" gap={0.5}>
                <Typography
                    component="span"
                    {...props}
                    sx={{
                        opacity: theme => employee.deactivated ? theme.palette.action.disabledOpacity : undefined,
                        ...props.sx,
                    }}
                >{employee.fullName}</Typography>
                {employee.deactivated && (
                    <Tag color="disabled" typography="caption">inactive</Tag>
                )}
            </Stack>
        </Link>
    );
}